import React, { Dispatch, SetStateAction } from 'react';
import { ButtonTypes } from '../../../../../../../../Interfaces/componentTypes';
import { VisitorPageContents } from '../../../../../visitorPage';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';
import Button from '../../../../../../../../Components/Button/button';
import { SuccessImg } from '../../../../../../../../Assets/Images';
import styles from './orderSuccess.module.scss';

interface IProps {
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>;
    onClose: () => void
}

const OrderSuccess: React.FC<IProps> = ({ setContentType, onClose }) => {
    const { t } = useLanguagesHooks();

    return (
        <div className={styles.container}>
            <div className={styles.textBox}>
                <p className={styles.title}>{t('Visitor.Success.Title')}</p>
            </div>
            <div className={styles.successContainer} >
                <div className={styles.checkmarkContainer}>
                    <img src={SuccessImg} alt='success.png' />
                </div>
                <div className={styles.textBox}>
                    <p className={styles.subtitle}>{t('Visitor.Success.Subtitle')}</p>
                    <p className={styles.nav}>{t('Visitor.Success.Nav')}</p>
                </div>
            </div>
            <Button
                buttonType={ButtonTypes.Success}
                buttonStyle={styles.animatedButton}
                title={t('Visitor.Success.Button')}
                buttonTitleStyle={styles.buttonTitle}
                onClick={() => {
                    setContentType(VisitorPageContents.MY_ORDERS);
                    onClose()
                }}
            />
        </div>
    )
}

export default OrderSuccess
